import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import btnClose from '../../images/common/close.svg';
import ColorSF2 from '../../styles/common/ColorSF2';

// TODO: 使っていないstyle削除すること。
const style = {
  main: {
    position: 'absolute',
    top: 0,
    left: 0,
    background: 'rgba(0,0,0,0.5)',
    height: '100vh',
    width: '100vw',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 999,
  },
  box: {
    width: 500,
    backgroundColor: ColorSF2.lightGray,
  },
  header: {
    height: 64,
    backgroundColor: ColorSF2.paleBlue,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: 16,
    padding: 10,
  },
  contents: {
    display: 'flex',
    flexDirection: 'column',
  },
  userName: {},
  closeButton: {
    margin: '20px 18px 20px 18px',
  },
  closeButtonImage: {
    width: 20,
    height: 20,
  },
  submit: {
    display: 'flex',
    justifyContent: 'center',
    margin: '20px 0',
  },
  updateButton: {
    color: ColorSF2.white,
    backgroundColor: ColorSF2.navyBlue,
    border: `1px solid ${ColorSF2.navyBlue}`,
    width: 200,
    height: 50,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 5,
    fontSize: 15,
  },
  userInfo: {
    display: 'flex',
    flexDirection: 'row',
    margin: '10px 10px 1px 10px',
    fontSize: 14,
    backgroundColor: ColorSF2.white,
    minHeight: 50,
  },
  userInfoTitle: {
    flex: '0 0 100px',
    backgroundColor: ColorSF2.paleBlue,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 10,
  },
  userInfoBody: {
    flex: '0 0 360px',
    backgroundColor: ColorSF2.white,
    minHeight: 60,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    paddingLeft: 10,
    flexWrap: 'wrap',
    position: 'relative',
  },
  operation: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
  input: {
    width: 340,
    lineHeight: '20px',
  },
  error: {
    backgroundColor: '#faa',
  },
  message: {
    fontSize: 12,
    color: 'red',
    display: 'flex',
    position: 'absolute',
    top: 41,
  },
};

const getButtonStyles = isPrimary => ({
  ...style.updateButton,
  backgroundColor: isPrimary ? ColorSF2.navyBlue : ColorSF2.white,
  color: isPrimary ? ColorSF2.white : ColorSF2.navyBlue,
});

const CreateCompanyDialog = ({
  confirmData,
  confirmDataError,
  onClose,
  onCreateCompany,
  onUpdateConfirm,
}) => {
  const companyCode = (confirmData && confirmData.companyCode) || '';
  const hasError = !!confirmData.errorCode;
  return (
    <div
      style={style.main}
      id="closeConfirmCompanyWindow"
      role="presentation"
      onClick={() => onClose()}
    >
      <div
        role="presentation"
        style={style.box}
        onClick={e => e.stopPropagation()}
      >
        <div style={style.contents}>
          <div style={style.header}>
            <div style={style.userName}>
              <FormattedMessage id="company.CompanyDialog.title.name" />
            </div>
            <div
              id="closeButton"
              role="presentation"
              className="button"
              style={style.closeButton}
              onClick={() => onClose()}
            >
              <img style={style.closeButtonImage} src={btnClose} alt="close" />
            </div>
          </div>
          <div style={style.userInfo}>
            <div style={style.userInfoTitle}>
              <FormattedMessage id="company.CompanyDialog.title.companyCode" />
            </div>
            <div style={style.userInfoBody}>
              <input
                id="updateConfirmInputForm"
                style={
                  (confirmDataError.companyCode && {
                    ...style.input,
                    ...style.error,
                  }) ||
                  style.input
                }
                type="text"
                defaultValue={companyCode}
                onChange={e => onUpdateConfirm({ companyCode: e.target.value })}
              />
              {hasError && (
                <div style={style.message}>
                  <FormattedMessage
                    id={`company.CompanyDialog.message.${confirmData.errorCode}`}
                  />
                </div>
              )}
            </div>
          </div>
          <div style={style.operation}>
            <div style={style.submit}>
              <div
                id="updateButtonClick"
                role="presentation"
                style={getButtonStyles(true)}
                className="button"
                onClick={() => {
                  if (companyCode !== '' && !confirmDataError.companyCode) {
                    onCreateCompany(companyCode);
                  }
                }}
              >
                <FormattedMessage id="company.CompanyDialog.button.create" />
              </div>
            </div>
            <div style={style.submit}>
              <div
                id="cancelButtonClick"
                role="presentation"
                style={getButtonStyles(false)}
                className="button"
                onClick={() => onClose()}
              >
                <FormattedMessage id="company.CompanyDialog.button.cancel" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

CreateCompanyDialog.propTypes = {
  confirmData: PropTypes.object.isRequired,
  confirmDataError: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onUpdateConfirm: PropTypes.func.isRequired,
  onCreateCompany: PropTypes.func.isRequired,
};

export default CreateCompanyDialog;
